<div class="image-container">
  <img
    deferLoad
    [ngClass]="{ 'image--loading': imageLoading }"
    [fallback]="fallbackImageUrl"
    [src]="stamp.recipe.imageUrl"
    (load)="imageLoading = false"
    [alt]="stamp.recipe.title"
  />
</div>

<p class="title">{{ stamp.recipe.title }}</p>

<div class="actions">
  <a cdxButton fillStyle="link" [fullWidth]="true" [href]="link" i18n="@@stampBasicViewRecipe" data-cy="viewRecipe">View recipe</a>
  
  <button
    cdxButton
    fillStyle="flat"
    (click)="saveOrUnsaveRecipe.emit({ id: stamp.recipe.id, isSaved: !!stamp.recipe.saved });"
    [attr.aria-label]="saveButtonAriaLabel"
  >
    <cdx-icon-circle [name]="stamp.recipe.saved ? 'heart-filled' : 'heart-thick'" background="light" iconFill="green" size="extra-small"></cdx-icon-circle>
  
  </button>
</div>